import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { uiActions } from '../../../store/ui-slice';
import SidePopup from './SidePopup';

const SidePopupMessage = () => {
    const sidePopup = useSelector((state) => state.ui.sidePopup);
    const dispatch = useDispatch();

    const closePopup = useCallback(() => {
        dispatch(uiActions.showSidePopup(null));
    }, [dispatch]);

    useEffect(() => {
        // Only set timer if we have a popup and it should auto-dismiss
        if (sidePopup && sidePopup.autoDismiss !== false) {
            const duration = sidePopup.duration || 4500;
            const timer = setTimeout(closePopup, duration);
            return () => clearTimeout(timer);
        }
    }, [sidePopup, closePopup]);

    if (!sidePopup) return null;

    return (
        <SidePopup 
            type={sidePopup.status} 
            header={sidePopup.header} 
            message={sidePopup.message} 
            autoDismiss={sidePopup.autoDismiss !== false}
            duration={sidePopup.duration || 4500}
            onClose={closePopup}
            zIndex={sidePopup.zIndex}
        />
    );
};

export default SidePopupMessage;
